export default {
      id: "icon-share-usage",
      viewBox: "0 0 24 24",
      url: "/" + "assets/sprite.svg#icon-share",
      toString: function () {
        return this.url;
      }
    }